export default __webpack_public_path__ + "static/media/aboutband_icon_04.aec0884e.png";